(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5874],{

/***/ 59719:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSP": function() { return /* binding */ __N_SSP; },
  "default": function() { return /* binding */ guides; }
});

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(59499);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/next-seo/lib/next-seo.module.js
var next_seo_module = __webpack_require__(2962);
// EXTERNAL MODULE: ./components_web/Header.js
var components_web_Header = __webpack_require__(67099);
// EXTERNAL MODULE: ./components_web/Footer.js
var components_web_Footer = __webpack_require__(52460);
// EXTERNAL MODULE: ./components_web/SideMenu.js
var components_web_SideMenu = __webpack_require__(92063);
// EXTERNAL MODULE: ./src/components/atoms/index.js + 38 modules
var atoms = __webpack_require__(52738);
// EXTERNAL MODULE: ./src/config/index.js + 8 modules
var config = __webpack_require__(54176);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./components_web/guides/component/GuideYear.js













var GuideYear = function GuideYear(props) {
  var _listData$sort;

  var _useTranslation = useTranslation(),
      t = _useTranslation.t;

  var router = useRouter();
  var listData = props.listData;

  var _useState = useState(false),
      sideMenuShow = _useState[0],
      setSideMenuShow = _useState[1];

  var _useState2 = useState(false),
      sideMenuHeaderShow = _useState2[0],
      setSideMenuHeaderShow = _useState2[1];

  var _useState3 = useState(false),
      isMobileVersion = _useState3[0],
      setIsMobileVersion = _useState3[1];

  useEffect(function () {
    setIsMobileVersion(Values.deviceWidth < 640);
  }, [Values.deviceWidth]);
  return /*#__PURE__*/_jsxs("div", {
    children: [/*#__PURE__*/_jsx(NextSeo, {
      noindex: false,
      nofollow: false,
      title: "Year Guides - ".concat("Beachful"),
      description: "Discover ".concat( false ? 0 :  false ? 0 :  false ? 0 :  false ? 0 :  true ? "beach clubs" : 0, " around the World with our guides."),
      canonical: "https://".concat("www.beachful.co", "/guides"),
      openGraph: {
        type: "website",
        locale: "en_EN",
        url: "https://".concat("www.beachful.co", "/guides"),
        title: "Year Guides - ".concat("Beachful"),
        description: "Discover ".concat( false ? 0 :  false ? 0 :  false ? 0 :  false ? 0 :  true ? "beach clubs" : 0, " around the World with our guides."),
        images: [{
          url: "https://".concat("www.beachful.co").concat("/images/og-beachful.png"),
          width: 1200,
          height: 630,
          alt: "".concat("Beachful").concat(" - The Beach Club You Need"),
          type: "image/png"
        }],
        siteName: "".concat("Beachful").concat(" - The Beach Club You Need")
      }
    }), /*#__PURE__*/_jsx(Header, {
      setSideMenuShow: setSideMenuShow
    }), /*#__PURE__*/_jsx(SideMenu, {
      sideMenuShow: sideMenuShow,
      setSideMenuShow: setSideMenuShow,
      sideMenuHeaderShow: sideMenuHeaderShow,
      setSideMenuHeaderShow: setSideMenuHeaderShow
    }), /*#__PURE__*/_jsx("div", {
      className: "bg-black",
      children: /*#__PURE__*/_jsx("div", {
        className: "mx-auto relative ".concat(isMobileVersion ? "px-[8px]" : "wrapper pt-[30px]", " pb-[130px]"),
        children: /*#__PURE__*/_jsxs("div", {
          className: "max-w-1160px min-h-screen flex-1 mx-auto",
          children: [/*#__PURE__*/_jsx(NavigationBar, {
            title: "Year",
            customStyle: isMobileVersion ? null : {
              marginTop: 0
            },
            isMobileVersion: isMobileVersion,
            onBackPressed: function onBackPressed() {
              var _process$env$NEXT_PUB, _process$env$NEXT_PUB2, _process$env$NEXT_PUB3, _process$env$NEXT_PUB4, _process$env$NEXT_PUB5;

              return router.push("/explore/".concat((_process$env$NEXT_PUB = "Venue Beachful".split(",")[0]) === null || _process$env$NEXT_PUB === void 0 ? void 0 : (_process$env$NEXT_PUB2 = _process$env$NEXT_PUB.toLowerCase()) === null || _process$env$NEXT_PUB2 === void 0 ? void 0 : (_process$env$NEXT_PUB3 = _process$env$NEXT_PUB2.replace("venue cocktail", "bars")) === null || _process$env$NEXT_PUB3 === void 0 ? void 0 : (_process$env$NEXT_PUB4 = _process$env$NEXT_PUB3.replace("venue beachful", "beach-clubs")) === null || _process$env$NEXT_PUB4 === void 0 ? void 0 : (_process$env$NEXT_PUB5 = _process$env$NEXT_PUB4.replace("prefab company", "companies")) === null || _process$env$NEXT_PUB5 === void 0 ? void 0 : _process$env$NEXT_PUB5.replace("prefab home", "homes")));
            }
          }), /*#__PURE__*/_jsx("div", {
            className: "flex flex-col items-center px-[20px]",
            children: listData === null || listData === void 0 ? void 0 : (_listData$sort = listData.sort(function (a, b) {
              return a.order - b.order;
            })) === null || _listData$sort === void 0 ? void 0 : _listData$sort.map(function (item, index) {
              return /*#__PURE__*/_jsx(Link, {
                href: "/guides/".concat(item === null || item === void 0 ? void 0 : item.slug),
                children: /*#__PURE__*/_jsx("a", {
                  className: "bg-gradient-to-bl from-gradient3 via-gradient2 to-gradient1 p-4 rounded-full text-xl text-white hover:underline font-semibold uppercase text-center w-full max-w-[330px] mb-[20px]",
                  children: item === null || item === void 0 ? void 0 : item.title
                })
              });
            })
          })]
        })
      })
    }), /*#__PURE__*/_jsx(Footer, {})]
  });
};

/* harmony default export */ var component_GuideYear = ((/* unused pure expression or super */ null && (GuideYear)));
// EXTERNAL MODULE: ./components_web/guides/component/GuideContinent.js
var GuideContinent = __webpack_require__(46497);
// EXTERNAL MODULE: ./node_modules/react-i18next/dist/es/useTranslation.js + 3 modules
var es_useTranslation = __webpack_require__(77058);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./src/helpers/formatHelpers.js
var formatHelpers = __webpack_require__(9465);
;// CONCATENATED MODULE: ./components_web/guides/component/GuideWorld.js















var GuideWorld = function GuideWorld(props) {
  var _showListData$sort;

  var _useTranslation = (0,es_useTranslation/* useTranslation */.$)(),
      t = _useTranslation.t;

  var router = (0,next_router.useRouter)();
  var listData = props.listData;

  var _useState = (0,react.useState)(false),
      sideMenuShow = _useState[0],
      setSideMenuShow = _useState[1];

  var _useState2 = (0,react.useState)(false),
      sideMenuHeaderShow = _useState2[0],
      setSideMenuHeaderShow = _useState2[1];

  var _useState3 = (0,react.useState)(false),
      isMobileVersion = _useState3[0],
      setIsMobileVersion = _useState3[1];

  var continents = config/* Constants.CONTINENTS */.gT.CONTINENTS;
  var showListData = listData.filter(function (i) {
    return i.region != null;
  }).map(function (item) {
    return continents.find(function (i) {
      return i.title === item.region;
    });
  });
  (0,react.useEffect)(function () {
    setIsMobileVersion(config/* Values.deviceWidth */.$m.deviceWidth < 640);
  }, [config/* Values.deviceWidth */.$m.deviceWidth]);
  return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(next_seo_module/* NextSeo */.PB, {
      noindex: false,
      nofollow: false,
      title: "".concat( false ? 0 : "World", " Guides - ").concat("Beachful"),
      description: "Discover ".concat( false ? 0 :  false ? 0 :  false ? 0 :  false ? 0 :  true ? "beach clubs" : 0).concat( false ? 0 : " around the World ", "with our guides."),
      canonical: "https://".concat("www.beachful.co", "/guides"),
      openGraph: {
        type: "website",
        locale: "en_EN",
        url: "https://".concat("www.beachful.co", "/guides"),
        title: "World Guides - ".concat("Beachful"),
        description: "Discover ".concat( false ? 0 :  false ? 0 :  false ? 0 :  false ? 0 :  true ? "beach clubs" : 0, " around the World with our guides."),
        images: [{
          url: "https://".concat("www.beachful.co").concat("/images/og-beachful.png"),
          width: 1200,
          height: 630,
          alt: "".concat("Beachful").concat(" - The Beach Club You Need"),
          type: "image/png"
        }],
        siteName: "".concat("Beachful").concat(" - The Beach Club You Need")
      }
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(components_web_Header/* default */.Z, {
      setSideMenuShow: setSideMenuShow
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(components_web_SideMenu/* default */.Z, {
      sideMenuShow: sideMenuShow,
      setSideMenuShow: setSideMenuShow,
      sideMenuHeaderShow: sideMenuHeaderShow,
      setSideMenuHeaderShow: setSideMenuHeaderShow
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: "".concat((0,formatHelpers/* getClass */.ll)("background", true)),
      children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: "mx-auto relative ".concat(isMobileVersion ? "px-[8px]" : "wrapper pt-[30px]", " pb-[130px]"),
        children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          className: "max-w-1160px min-h-screen flex-1 mx-auto",
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(atoms/* NavigationBar */.vx, {
            title:  false ? 0 : "World",
            customStyle: isMobileVersion ? null : {
              marginTop: 0
            },
            isMobileVersion: isMobileVersion,
            onBackPressed: function onBackPressed() {
              var _process$env$NEXT_PUB, _process$env$NEXT_PUB2, _process$env$NEXT_PUB3, _process$env$NEXT_PUB4, _process$env$NEXT_PUB5;

              return router.push("/explore/".concat((_process$env$NEXT_PUB = "Venue Beachful".split(",")[0]) === null || _process$env$NEXT_PUB === void 0 ? void 0 : (_process$env$NEXT_PUB2 = _process$env$NEXT_PUB.toLowerCase()) === null || _process$env$NEXT_PUB2 === void 0 ? void 0 : (_process$env$NEXT_PUB3 = _process$env$NEXT_PUB2.replace("venue cocktail", "bars")) === null || _process$env$NEXT_PUB3 === void 0 ? void 0 : (_process$env$NEXT_PUB4 = _process$env$NEXT_PUB3.replace("venue beachful", "beach-clubs")) === null || _process$env$NEXT_PUB4 === void 0 ? void 0 : (_process$env$NEXT_PUB5 = _process$env$NEXT_PUB4.replace("prefab company", "companies")) === null || _process$env$NEXT_PUB5 === void 0 ? void 0 : _process$env$NEXT_PUB5.replace("prefab home", "homes")));
            }
          }), ( false) && /*#__PURE__*/0, /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            className: "grid md:grid-cols-3 grid-cols-1 sm:gap-10 gap-5 px-[20px]",
            children: showListData === null || showListData === void 0 ? void 0 : (_showListData$sort = showListData.sort(function (a, b) {
              return a.order - b.order;
            })) === null || _showListData$sort === void 0 ? void 0 : _showListData$sort.map(function (item, index) {
              return /*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), {
                href: "/guides/".concat(item === null || item === void 0 ? void 0 : item.slug),
                children: /*#__PURE__*/(0,jsx_runtime.jsxs)("a", {
                  className: "".concat((0,formatHelpers/* getClass */.ll)("bg-card-continent", true), " flex flex-col justify-center items-center p-[75px] rounded-2xl cursor-pointer"),
                  children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                    className: "flex justify-center items-center w-[200px] h-[140px]",
                    children: /*#__PURE__*/(0,jsx_runtime.jsx)((image_default()), {
                      src: item === null || item === void 0 ? void 0 : item.map,
                      width: item === null || item === void 0 ? void 0 : item.mapWidth,
                      height: item === null || item === void 0 ? void 0 : item.mapHeight,
                      alt: item === null || item === void 0 ? void 0 : item.title,
                      objectFit: "contain"
                    })
                  }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                    className: "flex flex-col justify-center items-center ".concat((0,formatHelpers/* getClass */.ll)("bg-card-continent-label", true), " w-[240px] h-[50px] rounded-full text-white uppercase font-bold text-base text-center mt-[40px]"),
                    children: item === null || item === void 0 ? void 0 : item.title
                  })]
                }, index)
              });
            })
          })]
        })
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(components_web_Footer/* default */.Z, {})]
  });
};

/* harmony default export */ var component_GuideWorld = (GuideWorld);
;// CONCATENATED MODULE: ./pages/guides/index.js


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }







var GuideWorldPage = function GuideWorldPage(props) {
  if (false) {} else if (false) {} else if (false) {} else {
    return /*#__PURE__*/(0,jsx_runtime.jsx)(component_GuideWorld, _objectSpread({}, props));
  }
};

var __N_SSP = true;
/* harmony default export */ var guides = (GuideWorldPage);

/***/ }),

/***/ 48155:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/guides",
      function () {
        return __webpack_require__(59719);
      }
    ]);
    if(false) {}
  

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [3662,1664,2427,2738,2460,6497,9774,2888,179], function() { return __webpack_exec__(48155); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);